import type { SwitchProps } from '@mantine/core'
import { Switch as MantineSwitch, useMantineTheme } from '@mantine/core'

import classes from './Switch.module.css'

export function Switch({ ...props }: SwitchProps) {
  const theme = useMantineTheme()

  return (
    <MantineSwitch
      {...props}
      classNames={classes}
      color={theme.other.colors.switch}
      labelPosition="left"
      size="lg"
      styles={(theme, params) => ({
        track: {
          backgroundColor: params.checked
            ? theme.other.colors.switch
            : theme.other.colors.lightGrey,
          borderColor: params.checked
            ? theme.other.colors.switch
            : theme.other.colors.lightGrey,
        },
      })}
    />
  )
}
